import { render, staticRenderFns } from "./default-loading.vue?vue&type=template&id=adf654fc&scoped=true"
import script from "./default-loading.vue?vue&type=script&lang=js"
export * from "./default-loading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf654fc",
  null
  
)

export default component.exports